import { PlusOutlined } from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import {
    Button, Card, Collapse, ConfigProvider, Flex, Spin, theme as AntdTheme, theme, Typography,
} from 'antd';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { objectionsQueries } from '@/api';
import { RoleGuard } from '@/components';
import {
    AppRoute, DARK_THEME_HTML_BACKGROUND_COLOR, DEFAULT_ORDER_DIRECTION, UserRole,
} from '@/constants';
import { useUIStore } from '@/stores';
import { lightTheme } from '@/themes';

export const ObjectionsList = () => {
    const { token } = theme.useToken();
    const { theme: currentTheme } = useUIStore();
    const navigate = useNavigate();
    const { data, isFetching } = useQuery(objectionsQueries.getAllObjections({
        per_page: -1,
        current_page: 1,
        order_column: 'priority',
        order_direction: DEFAULT_ORDER_DIRECTION,
        search: '',
    }));

    const lightThemeToken = useMemo(() => {
        return AntdTheme.getDesignToken({
            algorithm: AntdTheme.defaultAlgorithm,
            ...lightTheme,
        });
    }, []);

    const items = data?.items?.map((objection) => ({
        key: objection.id,
        classNames: {
            body: 'wswg-content',
        },
        label: (
            <Typography.Text strong>
                {objection.title}
            </Typography.Text>
        ),
        children: (
            <ConfigProvider
                theme={{
                    algorithm: currentTheme === 'dark' ? AntdTheme.defaultAlgorithm : undefined,
                    token: currentTheme === 'dark' ? {
                        colorText: lightThemeToken.colorText,
                        colorLink: lightThemeToken.colorLink,
                    } : undefined,
                }}
            >
                <div
                    dangerouslySetInnerHTML={{
                        __html: objection.body || '-',
                    }}
                    style={{
                        padding: '8px',
                        // backgroundColor: currentTheme === 'dark' ? DARK_THEME_HTML_BACKGROUND_COLOR : 'transparent',
                        color: currentTheme === 'dark' ? lightThemeToken.colorText : undefined,
                    }}
                />
            </ConfigProvider>
        ),
    })) || [];

    const collapseContentBg = currentTheme === 'dark' ? DARK_THEME_HTML_BACKGROUND_COLOR : undefined;

    return (
        <Card title="Робота з запереченнями" size="small">
            <Spin spinning={isFetching}>
                <div style={{ flex: 1, overflow: 'auto', marginBottom: token.margin }}>
                    <ConfigProvider
                        theme={{
                            components: {
                                Collapse: {
                                    contentBg: collapseContentBg,
                                },
                            },
                        }}
                    >
                        <Collapse items={items} />
                    </ConfigProvider>
                </div>
                <RoleGuard roles={[UserRole.SuperAdmin, UserRole.Admin, UserRole.ScriptWriter]}>
                    <Flex justify="center">
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={() => navigate(AppRoute.ObjectionCreate)}
                        >
                            Додати заперечення
                        </Button>
                    </Flex>
                </RoleGuard>
            </Spin>
        </Card>
    );
};
